// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'

import {reducer as formReducer} from 'redux-form'
import sessionReducer from './sessionReducer'
import multiDRMReducer from './multiDRMReducer'
import spinnerReducer from './spinnerReducer'
import activateUserReducer from './activateUserReducer'
import resetPasswordReducer from './resetPasswordReducer'
import userManagementReducer from './userManagementReducer'
import auditViewerReducer from './auditViewerReducer'
import deviceManagementReducer from './deviceManagementReducer'
import domainManagementReducer from './domainManagementReducer'
import tableReducer from './tableReducer'
import areYouThereReducer from './areYouThereReducer'
import entitlementsReducer from './entitlementsReducers'
import buildIdReducer from './buildIdReducer'
import availableUpdateReducer from './availableUpdateReducer'
import timeKeeperReducer from './timeKeeperReducer'
import lookerReducer from './lookerReducer'
import bigButtonsReducer from './bigButtonsReducer'

export default (history) => combineReducers({
  router: connectRouter(history),
  form: formReducer,
  session: sessionReducer,
  multiDRM: multiDRMReducer,
  spinner: spinnerReducer,
  activateUser: activateUserReducer,
  resetPassword: resetPasswordReducer,
  userManagement: userManagementReducer,
  auditViewer: auditViewerReducer,
  deviceManagement: deviceManagementReducer,
  domainManagement: domainManagementReducer,
  table: tableReducer,
  areYouThere: areYouThereReducer,
  entitlementManagement: entitlementsReducer,
  buildId: buildIdReducer,
  update: availableUpdateReducer,
  timeKeeper: timeKeeperReducer,
  looker: lookerReducer,
  bigButtons: bigButtonsReducer
})
